import nativeCreate from './_nativeCreate.js';

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

export default hashClear;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_hashClear.js
// module id = 1247
// module chunks = 0